var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"lnk-router",on:{"click":_vm.goToProductList}},[_c('v-card',{attrs:{"height":"180","flat":""}},[_c('v-img',{attrs:{"height":"180","src":_vm.img,"contain":""}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }